module.exports = __webpack_public_path__ + "static/media/Primary language.5ae345e4.svg";